import { clsx } from 'clsx';
import React from 'react';
import { Colors, FontWeight, LineHeight } from '@common/tokens';

type Props = {
  content: React.ReactNode[][];
  labelWidth?: number | string;
  fullWidth?: boolean;
  className?: string;
  labelOrientation?: 'vertical' | 'horizontal' | 'none';
};

export const AlignedInfo = ({
  content,
  labelWidth = 150,
  fullWidth,
  className,
  labelOrientation = 'vertical',
}: Props) => {
  const finalClassName = clsx('wk-aligned-info', className, {
    'wk-aligned-info--full-width': fullWidth,
    'wk-aligned-info--vertical-label': labelOrientation === 'vertical',
    'wk-aligned-info--horizontal-label': labelOrientation === 'horizontal',
  });

  // Numbers are treated as pixels; string values (e.g. "12rem", "30%") pass
  // through verbatim.
  const labelWidthCss =
    typeof labelWidth === 'number' ? `${labelWidth}px` : labelWidth;

  function handleColKey(singleContent: React.ReactNode) {
    if (typeof singleContent === 'object') {
      // eslint-disable-next-line
      // @ts-ignore: reusing key from JSX element
      return singleContent?.key;
    }

    return singleContent;
  }

  return (
    <>
      <table className={finalClassName}>
        <tbody>
          {content.map((row, index) => (
            <tr className="wk-aligned-info__row" key={index.toString()}>
              {row.map((singleContent) => (
                <td
                  className="wk-aligned-info__col"
                  key={handleColKey(singleContent)}
                >
                  {singleContent}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <style jsx>{`
        .wk-aligned-info--full-width {
          width: 100%;
        }
        .wk-aligned-info--horizontal-label tr:first-child td {
          color: ${Colors.midnightLighter};
        }
        .wk-aligned-info--horizontal-label td {
          min-width: 150px;
        }
        .wk-aligned-info--vertical-label td:first-child {
          width: ${labelWidthCss};
          min-width: ${labelWidthCss};
          padding-right: 24px;
          color: ${Colors.midnightLighter};
        }
        .wk-aligned-info__col {
          min-width: 100px;
          font-weight: ${FontWeight.medium};
          line-height: ${LineHeight.sm};
          padding-bottom: 12px;
        }
        .wk-aligned-info__row:last-child .wk-aligned-info__col {
          padding-bottom: 0;
        }
      `}</style>
    </>
  );
};
